module.exports = __webpack_public_path__ + "img/product-bigData-one.ee82263.png";